import { Component, OnInit } from '@angular/core';
import { Tutorial } from './tutorial.model';

@Component({
  selector: 'fnsr-tutorials',
  standalone: true,
  templateUrl: './tutorials.component.html',
})
export class TutorialsComponent implements OnInit {
  tutorials: Tutorial[] = [];


  ngOnInit(): void {
    this.tutorials = [
      { hashtag: 'provenexpertsiegel',
        title: 'Proven Expert Bewertungssiegel anpassen und HTML-Code generieren',
        url: 'assets/media/videos/tutorials/bildadresse_aus_barmenia_homepagebaukasten_kopieren.m4v',
        thumbnailUrl: 'assets/media/videos/tutorials/bildadresse_aus_barmenia_homepagebaukasten_kopieren.png',
        subtitleUrl: 'assets/media/videos/tutorials/bildadresse_aus_barmenia_homepagebaukasten_kopieren.vtt',
        steps: [
          {
            text: 'Auf barmenia24 nach Webcode 9054 suchen',
            url: 'https://www.barmenia24.de/deu/b24_mein_auftritt/b24_online/b24_homepage/homepage.xhtml' },
          {
            text: '"Homepage pflegen" anklicken'
          },
          {
            text: '"Knowledge Graph" anklicken'
          },
          {
            text: '"Entitäten" anklicken'
          },
          {
            text: '"Barmenia Versicherung - ..." anklicken'
          },
          {
            text: 'Scrollen bis Google My Business-Felder'
          },
          {
            text: 'Rechtsklick auf "Bild in neuem Tab öffnen"'
          },
          {
            text: 'Tab anklicken'
          },
          {
            text: 'Url kopieren & an mich senden'
          }
        ]
      },
      {
        hashtag: 'titelbild',
        title: 'Bildadresse aus Barmenia Homepagebaukasten kopieren',
        url: 'assets/media/videos/tutorials/proven-expert-bewertungssiegel-anpassen-und-html-code-generieren.m4v',
        thumbnailUrl: 'assets/media/videos/tutorials/proven-expert-bewertungssiegel-anpassen-und-html-code-generieren.png',
        subtitleUrl: '',
      }
    ]
  }

  // let vid = document.querySelector('video');
  playVideo() {
    //   let but = document.querySelector('#play');

    //   if(vid.paused) {
    //   vid.play();
    //   but.textContent = "--Pause--";
    // } else {
    //   vid.pause();
    //   but.textContent = "Abspielen";
    // }
  }

  resize() {
    //   let siz = document.querySelector('#size');
    //   if(vid.width === 640) {
    //   vid.width = 720;
    //   siz.textContent = "Verkleinern";
    // } else {
    //   vid.width = 640;
    //   siz.textContent = "Vergrößern";
    // }
  }

  control() {
    //   let ctr = document.querySelector('#ctrl');
    //   if(vid.controls === false) {
    //   vid.controls = true;
    //   ctr.textContent = "Kontrollelemente ausblenden";
    // } else {
    //   vid.controls = false;
    //   ctr.textContent = "Kontrollelemente einblenden";
    // }
  }

  restart() {
    // vid.currentTime = 0;
    // skip um 10 Sekunden:
    // vid.currentTime += 10;
  }

  mute() {
    //   let mtxt = document.querySelector('#mute');
    //   if(vid.muted) {
    //   vid.muted = false;
    //   mtxt.textContent = "Ton aus";
    // } else {
    //   vid.muted = true;
    //   mtxt.textContent = "Ton an";
    // }
  }
}
